import { SelectionColumn, SELECTION_CELL_ID } from '../columns';
export const useSelectionCell = (isSelectable, selectionMode, isRowDisabled) => (hooks) => {
    if (!isSelectable) {
        return;
    }
    hooks.allColumns.push((columns) => selectionMode === 'single' ||
        columns.find((c) => c.id === SELECTION_CELL_ID)
        ? columns
        : [SelectionColumn({ isDisabled: isRowDisabled }), ...columns]);
};
